import { Box, SlideFade } from '@chakra-ui/react';
import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import type { User } from '@/models';
import { Footer } from './Footer';
import { SiteNav } from './Navbar/SiteNav';

export const PageContainer = ({ children }: { children: ReactNode }) => (
  <Box maxWidth={'1444px'} margin='auto' minH={'100svh'}>
    {children}
  </Box>
);

export function AuthedPageContainer({
  children,
  userData,
}: {
  children: ReactNode;
  userData?: User;
}) {
  const location = useLocation();
  const skipEnterAnimation = location.pathname.startsWith('/league/');

  const shell = (
    <PageContainer>
      <SiteNav userData={userData} />
      <Box as='main' width='full'>
        {children}
      </Box>
      <Footer />
    </PageContainer>
  );

  if (skipEnterAnimation) {
    return shell;
  }

  return <SlideFade in>{shell}</SlideFade>;
}
